/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      // navbar stuff
      // check if user has scrolled. if so apply active class
      const nav = document.querySelector( '.navbar' );

      // get the height of the site banner and update the variable
      const updateSiteBanner = () => {
        if ( $( '.site-banner' ).length > 0 ) {
          const siteBanner = $( '.site-banner' ).outerHeight();
          $( ':root' ).css( '--site-banner', `${Math.ceil( siteBanner )}px` );
        }
      };

      updateSiteBanner();

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.mobile-primary-nav' ).slideToggle();
      } );


      const checkNav = () => {
        if ( window.pageYOffset > 25 && nav !== null ) {
          nav.classList.add( 'active' );
        } else if ( window.pageYOffset <= 25 && nav !== null ) {
          nav.classList.remove( 'active' );
        }
      };

      checkNav();

      window.addEventListener( 'scroll', checkNav );

      // CLICKABLE CARDS IN NAV
      const navCards = document.querySelectorAll( '.card-outer' );

      function navLinkBoxes( navCards ) {
        navCards.forEach( function( box ) {
          const link = box.querySelector( 'a' );
          if ( link ) {
            const url = link.getAttribute( 'href' );
            box.addEventListener( 'click', function() {
              location.href = url;
              link.preventDefault;
            } );
          }
        } );
      }

      if ( navCards.length > 0 ) {
        navLinkBoxes( navCards );
      }

      // Switch data-src to source on any image with class lazy
      const switchImageSrc = ( images ) => {
        images.each( function( index, element ) {
          if ( $( element ).hasClass( 'll-lazy' ) ) {
            const sourceSet = $( element ).attr( 'data-srcset' );
            const source = $( element ).attr( 'data-src' );
            $( element ).attr( 'srcset', sourceSet );
            $( element ).attr( 'src', source );
            $( element ).removeClass( 'll-lazy' );
          }
        } );
      };

      // add event listener to switch any images with custom lazy load
      $( '*[data-lazy]' ).each( function( index, element ) {
        $( this ).on( 'click', function() {
          const images = $( $( this ).attr( 'data-lazy' ) ).find( '.ll-lazy' );
          // load images
          if ( images.length > 0 ) {
            switchImageSrc( images );
          }
        } );
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        iframe: {
          markup:
              '<div class="mfp-iframe-scaler">'+
              '<div class="mfp-close"></div>'+
              '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
              '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
        },
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            // get the current instance of the magnificPopup
            const magnificPopup = $.magnificPopup.instance;
            // get the title from data attribute added to button
            const title = magnificPopup.currItem.el.data( 'title' );
            if ( title ) {
              // get the currrent iframe element
              const currIframe = magnificPopup.currTemplate.iframe.find( 'iframe' );

              // add title to the iframe
              currIframe.prop( 'title', title );
            }
            // add a role to the container for accessabilty
            magnificPopup.contentContainer.attr( 'role', 'dialog' );
            magnificPopup.contentContainer.attr( 'aria-label', `${title} player` );

            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '#search-panel-mobile' ).find( '.inner-search-panel' ).find( 'label' ).attr( 'for', 'nav-search-mobile' );
      $( '#search-panel-mobile' ).find( '.inner-search-panel' ).find( 'input' ).attr( 'id', 'nav-search-mobile' );

      // add event listeners for tabing outside of the nav
      $( '.mobile-primary-nav' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget !== null ) {
          const reltarget = $( event.relatedTarget );
          const currenttarget = $( event.currentTarget );
          if ( !reltarget.closest( '.mobile-primary-nav' ).is( currenttarget ) ) {
            if ( $( reltarget ).get( 0 ) === $( '.navbar-toggle' ).get( 0 ) ) {
              forceToggle( true );
            } else {
              forceToggle( );
            }
          }
        }
      } );

      $( '#search-panel-mobile' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget !== null ) {
          const reltarget = $( event.relatedTarget );
          const currenttarget = $( event.currentTarget );
          if ( !reltarget.closest( '#search-panel-mobile' ).is( currenttarget ) ) {
            forceToggle();
          }
        }
      } );

      $( '#search-panel' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget !== null ) {
          const reltarget = $( event.relatedTarget );
          const currenttarget = $( event.currentTarget );
          if ( !reltarget.closest( '#search-panel' ).is( currenttarget ) ) {
            forceToggle();
          }
        }
      } );

      $( '#primary-nav' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget !== null ) {
          const reltarget = $( event.relatedTarget );
          const currenttarget = $( event.currentTarget );
          if ( !reltarget.closest( '#primary-nav' ).is( currenttarget ) ) {
            forceToggle();
          }
        }
      } );

      // get all active easytoggle triggers and force a click to close them
      const forceToggle = ( isToggle = false ) => {
        // check active state for all easytoggle elements
        $( '.primary-menu-link.is-open' ).each( function() {
          $( this ).trigger( 'click' );
        } );
        if ( !isToggle ) {
          $( '.navbar-toggle.is-open' ).each( function() {
            $( this ).trigger( 'click' );
          } );
        }
      };

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        updateSiteBanner();
        forceToggle();
      } );

      // trigger next button on radio page radio change unless they click 'other' field
      $( document ).on( 'change', '.llgq-current-page input[type="radio"]', function() {
        if ( $( '.llgq-current-page' ).hasClass( 'llgq-radio-page-other' ) && $( this ).val() !== 'gfield-other-trigger' ) {
          $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
        } else if ( $( '.llgq-current-page' ).hasClass( 'llgq-radio-page-other' ) && $( this ).val() === 'gfield-other-trigger' ) {
          $( '.llgq-current-page .gform_next_button, .llgq-quoter-next' ).removeClass( 'llgq-radio-page-hidden' );
        }
      } );
      // hide next button on radio page
      if ( $( '.gform_wrapper .gform_page:first-child' ).hasClass( 'llgq-radio-page-other' ) ) {
        $( '.llgq-current-page .gform_next_button, .llgq-quoter-next' ).addClass( 'llgq-radio-page-hidden' );
      } else {
        $( '.llgq-current-page .gform_next_button, .llgq-quoter-next' ).removeClass( 'llgq-radio-page-hidden' );
      }
      // ON QUOTER PAGE CHANGE
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
      // trigger next button on radio page radio change unless they click 'other' field
        $( document ).on( 'change', '.llgq-current-page input[type="radio"]', function() {
          if ( $( '.llgq-current-page' ).hasClass( 'llgq-radio-page-other' ) && $( this ).val() !== 'gfield-other-trigger' ) {
            $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
          } else if ( $( '.llgq-current-page' ).hasClass( 'llgq-radio-page-other' ) && $( this ).val() === 'gfield-other-trigger' ) {
            $( '.llgq-current-page .gform_next_button, .llgq-quoter-next' ).removeClass( 'llgq-radio-page-hidden' );
          }
        } );
        // hide next button on radio page
        if ( $( '.gform_wrapper .gform_page:first-child' ).hasClass( 'llgq-radio-page-other' ) ) {
          $( '.llgq-current-page .gform_next_button, .llgq-quoter-next' ).addClass( 'llgq-radio-page-hidden' );
        } else {
          $( '.llgq-current-page .gform_next_button, .llgq-quoter-next' ).removeClass( 'llgq-radio-page-hidden' );
        }
        // if checkbox clicked show next
        $( document ).on( 'change', '.llgq-current-page input[type="checkbox"]', function() {
          $( '.llgq-current-page .gform_next_button, .llgq-quoter-next' ).removeClass( 'llgq-radio-page-hidden' );
        } );
        // if number input filled show next btn
        $( document ).on( 'change', '.llgq-current-page input[type="number"]', function() {
          $( '.llgq-current-page .gform_next_button, .llgq-quoter-next' ).removeClass( 'llgq-radio-page-hidden' );
        } );
        // if select input filled show next btn
        $( document ).on( 'change', '.llgq-current-page select', function() {
          $( '.llgq-current-page .gform_next_button, .llgq-quoter-next' ).removeClass( 'llgq-radio-page-hidden' );
        } );
      } );

      $( document ).on( 'gform_confirmation_loaded', function() {
        if ( $( '.contact-form-intro' ).length !== 0 ) {
          $( '.contact-form-intro' ).addClass( 'hidden' );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
